import { createRouter, createWebHistory } from 'vue-router'
import { Routes } from './routes'

import { Login, Auth, SignUp } from '@/ui/page/auth'

import { ChatsHistory } from '@/ui/page/chats-history'
import { ChatPage } from '@/ui/page/chat-page'
import { ChatPageId } from '@/ui/page/chat-page-id'
import { createAuthGuard } from '@/domain/auth-guard/auth-guard'

import NotFound from '@/ui/page/404/index.vue'

export const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: `/${Routes.SignUp}`,
      name: Routes.SignUp,
      component: SignUp,
      meta: {
        layout: 'auth',
      },
      beforeEnter: createAuthGuard({ onlyUnAuthorized: true }),
    },
    {
      path: `/${Routes.Login}`,
      name: Routes.Login,
      component: Login,
      meta: {
        layout: 'auth',
      },
      beforeEnter: createAuthGuard({ onlyUnAuthorized: true }),
    },
    {
      path: `/${Routes.Auth}`,
      name: Routes.Auth,
      component: Auth,
      meta: {
        layout: 'auth',
      },
    },
    {
      path: '/',
      redirect: `/${Routes.Chat}`,
      beforeEnter: createAuthGuard({ requiresAuth: true }),
    },
    {
      path: `/${Routes.Chat}`,
      name: Routes.Chat,
      component: ChatPage,
      props: true,
      beforeEnter: createAuthGuard({ requiresAuth: true }),
    },

    {
      path: `/${Routes.Chat}/:id`,
      name: `${Routes.ChatDetail}`,
      component: ChatPageId,
      props: true,
      beforeEnter: createAuthGuard({ requiresAuth: true }),
    },
    {
      path: `/${Routes.ChatsHistory}`,
      name: Routes.ChatsHistory,
      component: ChatsHistory,
      beforeEnter: createAuthGuard({ requiresAuth: true }),
    },
    {
      path: '/:pathMatch(.*)*',
      name: Routes.NotFound,
      component: NotFound,
      meta: {
        layout: 'auth',
      },
    },
  ],
})
